module.exports = __webpack_public_path__ + "static/media/github.3480db5e.png";